export default __webpack_public_path__ + "static/baseline-pic-30e0964007003fbad939be82fbc1021f.jpg";